module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAANRJREFUaAXt2MENwyAMQNGAIm5doNO0N5iq7QDtOnDrNJmgA1AWsCMholji54hlxzxfLJaFDwEEEEAAAQQQQACByQScdt+c81OLnx1LKYn9rVpzzrmHFjcQEy/mDTR3SAvqxGqtr0P+SlEEEEAAAQQQmFNAXYJLKV/LLDHGu9SfulK1pJuUaP182iVYHLX1idEfAggggAACCBgU2FuCt5E9t+e8d3u9/YysKdXaW4KvUmLPuff+0pPXkzPnEtykhk4shPDr0ScHAQQQQAABBBBA4BSBP6QCGWzWcoULAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_menu.png
// module id = 278
// module chunks = 0 1 2 4 5 6 7 8